import { cn } from "@/lib/utils";
import Link from "next/link";
import React from "react";

interface CommonButtonProps {
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "outline" | "ghost";
  size?: "sm" | "md" | "lg";
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  fullWidth?: boolean;
  href?: string;
}

const CommonButton: React.FC<CommonButtonProps> = ({
  children,
  variant = "primary",
  size = "md",
  className = "",
  onClick,
  disabled = false,
  type = "button",
  fullWidth = false,
  href,
}) => {
  const baseClasses =
    "inline-flex items-center justify-center font-semibold transition-all duration-300 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed select-none cursor-pointer";

  const sizeClasses = {
    sm: "h-10 px-3 py-2 text-sm rounded-full",
    md: "h-11 px-4 py-2 text-base rounded-full",
    lg: "h-13 px-6 py-3 text-base rounded-full",
  };

  const variantClasses = {
    primary: "!bg-[#000929] hover:!bg-[#000929]/90 !text-white",
    secondary: "bg-gray-600 hover:bg-gray-700 text-white",
    outline:
      "bg-white text-[#000929]/80 border border-gray-300 hover:bg-gray-100/90 hover:text-[#000929] transition-colors duration-200",
    ghost:
      "bg-transparent text-[#ED1947] hover:bg-[#ED1947]/10 hover:text-[#ED1947]",
  };

  const widthClasses = fullWidth ? "w-full" : "w-auto";

  const buttonClasses = cn(
    baseClasses,
    sizeClasses[size],
    variantClasses[variant],
    widthClasses,
    className
  );

  return (
    <Link href={href ?? ""}>
      <button
        type={type}
        className={buttonClasses}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
    </Link>
  );
};

export default CommonButton;
